var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOppsmsg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_26754",
    "data-name": "Group 26754",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 103.233,
    height: 106.614,
    viewBox: "0 0 103.233 106.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12005",
    "data-name": "Rectangle 12005",
    width: 103.233,
    height: 106.614,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26753",
    "data-name": "Group 26753",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23353",
    "data-name": "Path 23353",
    d: "M62.33,124.6c.022.5.037.82.057,1.248,1.712,0,3.349,0,4.986,0,1.1,0,1.657.4,1.691,1.157.035.789-.6,1.293-1.687,1.294q-7.209.009-14.42,0c-.134,0-.27,0-.4-.006-.781-.058-1.3-.46-1.289-1.257s.527-1.191,1.33-1.189c1.539,0,3.078,0,4.693,0,.032-.41.058-.729.093-1.174-.41-.028-.762-.072-1.115-.073-2.622-.006-5.243,0-7.865,0a7.922,7.922,0,0,1-.906-.023,1.153,1.153,0,0,1-1.154-1.171,1.176,1.176,0,0,1,1.179-1.254,6.416,6.416,0,0,1,.806-.017H71.417c1.343,0,1.927.377,1.932,1.229s-.586,1.235-1.921,1.237q-3.933,0-7.865,0H62.33",
    transform: "translate(-8.231 -21.693)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23354",
    "data-name": "Path 23354",
    d: "M39.587,124.6c-.8,0-1.608.015-2.41,0a1.227,1.227,0,1,1,.013-2.448c1.574-.017,3.148-.021,4.721,0a1.226,1.226,0,1,1-.014,2.446c-.77.02-1.54,0-2.31,0",
    transform: "translate(-6.373 -21.693)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23355",
    "data-name": "Path 23355",
    d: "M84.379,122.144c.8,0,1.609-.025,2.411.007a1.175,1.175,0,0,1,1.269,1.262,1.15,1.15,0,0,1-1.248,1.177q-2.41.037-4.822,0a1.22,1.22,0,1,1-.021-2.438c.8-.031,1.608-.007,2.411-.007",
    transform: "translate(-14.337 -21.693)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23356",
    "data-name": "Path 23356",
    d: "M60.975,82.545a12.019,12.019,0,0,1,9.59,5.245c.419.58.59,1.246-.015,1.7a2.076,2.076,0,0,1-1.451.213c-.283-.048-.515-.489-.738-.777a9.509,9.509,0,0,0-8.21-3.9,9.693,9.693,0,0,0-7.341,3.656c-.193.232-.363.484-.558.715a1.162,1.162,0,0,1-1.693.267A1.062,1.062,0,0,1,50.284,88a23.9,23.9,0,0,1,3.17-3.194,11.879,11.879,0,0,1,7.521-2.257",
    transform: "translate(-8.879 -14.662)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23357",
    "data-name": "Path 23357",
    d: "M125,117.245c-.151.118-.3.243-.456.35a1.155,1.155,0,0,1-1.688-.183,1.1,1.1,0,0,1,.076-1.616,1.132,1.132,0,0,1,1.69-.019,3.429,3.429,0,0,1,.378.46Z",
    transform: "translate(-21.765 -20.499)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23358",
    "data-name": "Path 23358",
    d: "M45.769,98.574A39.623,39.623,0,0,1,14.538,55.1a39.332,39.332,0,0,1,77.69-2.536,37.955,37.955,0,0,1-6.073,29.3c-5.988,8.864-14.371,14.283-24.77,16.7H94.03a5.365,5.365,0,0,1,.906.02c.69.118,1.178.579,1,1.246-.116.446-.624.825-1.028,1.144-.167.132-.521.032-.789.032H13.06c-.2,0-.4.007-.605,0a1.133,1.133,0,0,1-1.222-1.189c-.01-.813.47-1.215,1.268-1.247.269-.011.538,0,.807,0H45.769ZM90.482,59.948A36.889,36.889,0,1,0,53.6,96.748a36.943,36.943,0,0,0,36.879-36.8",
    transform: "translate(-1.995 -3.649)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23359",
    "data-name": "Path 23359",
    d: "M117.927,117.861c-1.515.006-2.1-.347-2.076-1.246.023-.853.6-1.19,2.042-1.19.334,0,.669-.012,1,.007a1.155,1.155,0,0,1,1.217,1.2,1.141,1.141,0,0,1-1.183,1.225c-.333.023-.669,0-1,0",
    transform: "translate(-20.577 -20.501)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23360",
    "data-name": "Path 23360",
    d: "M6.659,115.442c.368,0,.834-.141,1.08.031.414.291.951.785.946,1.187a1.616,1.616,0,0,1-.978,1.132,6.157,6.157,0,0,1-1.989.06,1.133,1.133,0,0,1-1.229-1.18,1.163,1.163,0,0,1,1.267-1.249c.3-.012.6,0,.9,0v.021",
    transform: "translate(-0.797 -20.495)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23361",
    "data-name": "Path 23361",
    d: "M2.42,116.623a1.152,1.152,0,0,1-1.192,1.229,1.2,1.2,0,1,1-.048-2.4,1.152,1.152,0,0,1,1.239,1.171",
    transform: "translate(0 -20.506)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23362",
    "data-name": "Path 23362",
    d: "M82.976,60.126a6.752,6.752,0,1,1-6.825-6.731,6.729,6.729,0,0,1,6.825,6.731m-7.219-4.147A4.167,4.167,0,0,0,72,60.853,4.316,4.316,0,0,0,76.927,64.4a4.167,4.167,0,0,0,3.432-5.091c-1.726,1.625-2.989,1.882-4.28.873-1.26-.985-1.382-2.377-.321-4.206",
    transform: "translate(-12.339 -9.484)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23363",
    "data-name": "Path 23363",
    d: "M45.584,66.907a6.756,6.756,0,1,1,6.758-6.8,6.751,6.751,0,0,1-6.758,6.8M41.462,59.3a4.089,4.089,0,0,0,2,4.59,4.29,4.29,0,0,0,6.008-5.555A3.56,3.56,0,0,0,46.1,56.087c1.025,1.618.924,3.048-.285,4.053-1.3,1.078-2.674.811-4.349-.843",
    transform: "translate(-6.897 -9.484)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23364",
    "data-name": "Path 23364",
    d: "M35.56,51.161a13.619,13.619,0,0,1-1.408-.009c-.8-.082-1.361-.509-1.272-1.369.082-.794.651-1.108,1.437-1.072a14.994,14.994,0,0,0,8.059-1.723,24.357,24.357,0,0,0,2.884-2c.833-.628,1.536-.7,2.037-.113s.354,1.312-.429,1.993a17.055,17.055,0,0,1-11.307,4.29",
    transform: "translate(-5.838 -7.9)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23365",
    "data-name": "Path 23365",
    d: "M85.785,50.782a17.484,17.484,0,0,1-10.631-3.664c-.188-.141-.365-.3-.549-.442a1.239,1.239,0,0,1-.379-1.836c.445-.651,1.183-.692,1.926-.06a14.038,14.038,0,0,0,6.818,3.228,35.283,35.283,0,0,0,4.2.325c.954.046,1.569.454,1.529,1.2a1.239,1.239,0,0,1-1.4,1.248c-.5.006-1.006,0-1.508,0",
    transform: "translate(-13.137 -7.874)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23366",
    "data-name": "Path 23366",
    d: "M113.9,57.645a1.2,1.2,0,1,1-1.189-1.187,1.2,1.2,0,0,1,1.189,1.187m-1.194-.5a.514.514,0,0,0-.515.518.505.505,0,0,0,.489.512.515.515,0,1,0,.025-1.03",
    transform: "translate(-19.805 -10.028)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23367",
    "data-name": "Path 23367",
    d: "M20.209,29.221a1.2,1.2,0,1,1-1.189-1.187,1.2,1.2,0,0,1,1.189,1.187m-1.194-.5a.514.514,0,0,0-.515.518.505.505,0,0,0,.489.512.515.515,0,1,0,.025-1.03",
    transform: "translate(-3.163 -4.979)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23368",
    "data-name": "Path 23368",
    d: "M118.985,20.307a1.2,1.2,0,1,1-1.189-1.188,1.2,1.2,0,0,1,1.189,1.188m-1.194-.5a.514.514,0,0,0-.515.518.505.505,0,0,0,.489.512.515.515,0,1,0,.025-1.03",
    transform: "translate(-20.708 -3.396)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23369",
    "data-name": "Path 23369",
    d: "M48.489,8.951a1.82,1.82,0,1,1-1.8-1.8,1.827,1.827,0,0,1,1.8,1.8m-1.811-.757a.78.78,0,0,0-.781.786.767.767,0,0,0,.743.776A.791.791,0,0,0,47.451,9a.8.8,0,0,0-.773-.8",
    transform: "translate(-7.966 -1.27)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23370",
    "data-name": "Path 23370",
    d: "M5.177,35.051H1.635a.206.206,0,1,1,0-.411H5.177a.206.206,0,1,1,0,.411",
    transform: "translate(-0.254 -6.153)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23371",
    "data-name": "Path 23371",
    d: "M4.539,36.22a.2.2,0,0,1-.173-.095l-1.914-2.98a.205.205,0,1,1,.345-.222L4.712,35.9a.2.2,0,0,1-.062.284.2.2,0,0,1-.111.033",
    transform: "translate(-0.43 -5.831)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23372",
    "data-name": "Path 23372",
    d: "M2.626,36.219a.2.2,0,0,1-.111-.033.2.2,0,0,1-.062-.284l1.914-2.98a.205.205,0,1,1,.345.222L2.8,36.125a.2.2,0,0,1-.173.095",
    transform: "translate(-0.43 -5.831)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23373",
    "data-name": "Path 23373",
    d: "M21.174,14.156H20.163l.547-.851a.149.149,0,1,0-.25-.16l-.569.885-.568-.885a.149.149,0,0,0-.251.16l.547.851H18.607a.149.149,0,0,0,0,.3h1.012l-.547.851a.149.149,0,0,0,.045.206.144.144,0,0,0,.081.024.148.148,0,0,0,.125-.069l.568-.885.569.885a.146.146,0,0,0,.125.069.14.14,0,0,0,.08-.024.148.148,0,0,0,.045-.206l-.546-.851h1.011a.149.149,0,1,0,0-.3",
    transform: "translate(-3.278 -2.322)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23374",
    "data-name": "Path 23374",
    d: "M93.83,17.8H90.746a.179.179,0,1,1,0-.358H93.83a.179.179,0,0,1,0,.358",
    transform: "translate(-16.086 -3.099)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23375",
    "data-name": "Path 23375",
    d: "M93.274,18.821a.179.179,0,0,1-.15-.082l-1.666-2.6a.179.179,0,1,1,.3-.193l1.667,2.6a.178.178,0,0,1-.054.247.169.169,0,0,1-.1.029",
    transform: "translate(-16.24 -2.818)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23376",
    "data-name": "Path 23376",
    d: "M91.607,18.821a.169.169,0,0,1-.1-.029.178.178,0,0,1-.054-.247l1.667-2.6a.179.179,0,1,1,.3.193l-1.666,2.6a.179.179,0,0,1-.15.082",
    transform: "translate(-16.239 -2.818)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23377",
    "data-name": "Path 23377",
    d: "M73.661,1.937H70.577a.179.179,0,1,1,0-.358h3.084a.179.179,0,0,1,0,.358",
    transform: "translate(-12.504 -0.28)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23378",
    "data-name": "Path 23378",
    d: "M73.105,2.954a.179.179,0,0,1-.15-.082L71.289.276a.179.179,0,1,1,.3-.193l1.667,2.6a.178.178,0,0,1-.054.247.169.169,0,0,1-.1.029",
    transform: "translate(-12.657 0)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23379",
    "data-name": "Path 23379",
    d: "M71.438,2.954a.169.169,0,0,1-.1-.029.178.178,0,0,1-.054-.247l1.667-2.6a.179.179,0,1,1,.3.193l-1.666,2.6a.179.179,0,0,1-.151.082",
    transform: "translate(-12.657 0)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23380",
    "data-name": "Path 23380",
    d: "M111.23,36.325h-2.8a.162.162,0,0,1,0-.325h2.8a.162.162,0,0,1,0,.325",
    transform: "translate(-19.231 -6.394)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23381",
    "data-name": "Path 23381",
    d: "M110.725,37.247a.162.162,0,0,1-.137-.075l-1.512-2.354a.162.162,0,0,1,.273-.175L110.862,37a.161.161,0,0,1-.049.224.153.153,0,0,1-.087.026",
    transform: "translate(-19.37 -6.14)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23382",
    "data-name": "Path 23382",
    d: "M109.214,37.247a.153.153,0,0,1-.087-.026.161.161,0,0,1-.049-.224l1.512-2.354a.162.162,0,0,1,.273.175l-1.512,2.354a.162.162,0,0,1-.137.075",
    transform: "translate(-19.37 -6.14)",
    fill: "#ff3d00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOppsmsg);
export default __webpack_public_path__ + "static/media/oppsmsg.5770ead606ac0cb9d21f77762908b142.svg";
export { ForwardRef as ReactComponent };